var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "basic-layout",
    [
      _c(
        "md-app",
        [
          _c(
            "md-app-toolbar",
            { staticClass: "md-primary", attrs: { "md-elevation": "0" } },
            [
              !_vm.isAuthenticated()
                ? _c("div", { staticClass: "md-toolbar-row" }, [
                    _c("div", { staticClass: "md-toolbar-section-start" }, [
                      _c("div", { staticClass: "md-title" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("admintools")) +
                            "\n          "
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isAuthenticated()
                ? _c("div", { staticClass: "md-toolbar-row" }, [
                    _c(
                      "div",
                      { staticClass: "md-toolbar-section-start" },
                      [
                        !_vm.menuVisible
                          ? _c(
                              "md-button",
                              {
                                staticClass: "md-icon-button",
                                on: { click: _vm.toggleMenu }
                              },
                              [_c("md-icon", [_vm._v("menu")])],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "md-title" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("admintools")) +
                              "\n          "
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "md-toolbar-section-end" },
                      [
                        _vm.selectedBillingCompany
                          ? _c(
                              "md-button",
                              {
                                staticClass:
                                  "billing-company-button md-xsmall-hide",
                                on: { click: _vm.changeBillingCompany }
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.selectedBillingCompany.companyName
                                    ) +
                                    "\n          "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "md-menu",
                          { attrs: { "md-direction": "bottom-start" } },
                          [
                            _c(
                              "md-button",
                              { attrs: { "md-menu-trigger": "" } },
                              [
                                !_vm.user || !_vm.user.thumbPictureUrl
                                  ? _c("md-icon", [_vm._v("account_circle")])
                                  : _c("md-avatar", [
                                      _c("img", {
                                        attrs: {
                                          src: _vm.user.thumbPictureUrl,
                                          alt: _vm.user.accountUsername
                                        }
                                      })
                                    ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "md-menu-content",
                              [
                                _c(
                                  "md-menu-item",
                                  { on: { click: _vm.changeBillingCompany } },
                                  [_vm._v("Change billing company")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "md-menu-item",
                                  { on: { click: _vm.logout } },
                                  [_vm._v("Logout")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c(
            "md-app-drawer",
            {
              attrs: { "md-active": _vm.menuVisible },
              on: {
                "update:mdActive": function($event) {
                  _vm.menuVisible = $event
                },
                "update:md-active": function($event) {
                  _vm.menuVisible = $event
                }
              }
            },
            [
              _c(
                "md-toolbar",
                {
                  staticClass: "md-transparent",
                  attrs: { "md-elevation": "0" }
                },
                [
                  _c("div", { staticClass: "md-toolbar-section-start" }, [
                    _c("img", {
                      attrs: {
                        src: require("../../assets/img/mywellness-logo.png"),
                        alt: "mywellness"
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "md-toolbar-section-end" },
                    [
                      _c(
                        "md-button",
                        {
                          staticClass: "md-icon-button md-dense",
                          on: { click: _vm.toggleMenu }
                        },
                        [_c("md-icon", [_vm._v("keyboard_arrow_left")])],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "md-list",
                [
                  _vm.currentEnvironment === "debug" ||
                  _vm.currentEnvironment === "development"
                    ? _c(
                        "md-list-item",
                        { attrs: { "md-expand": "" } },
                        [
                          _c("md-icon", [_vm._v("create")]),
                          _vm._v(" "),
                          _c("span", { staticClass: "md-list-item-text" }, [
                            _vm._v(_vm._s(_vm.$t("testenvironment")))
                          ]),
                          _vm._v(" "),
                          _c(
                            "md-list",
                            { attrs: { slot: "md-expand" }, slot: "md-expand" },
                            [
                              _c(
                                "md-list-item",
                                {
                                  staticClass: "md-inset",
                                  on: { click: _vm.createTestFacility }
                                },
                                [_vm._v("Club")]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-list-item",
                                {
                                  staticClass: "md-inset",
                                  on: { click: _vm.createTestChain }
                                },
                                [_vm._v("Chain")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "md-list-item",
                    { attrs: { "md-expand": "" } },
                    [
                      _c("md-icon", [_vm._v("search")]),
                      _vm._v(" "),
                      _c("span", { staticClass: "md-list-item-text" }, [
                        _vm._v("Search")
                      ]),
                      _vm._v(" "),
                      _c(
                        "md-list",
                        { attrs: { slot: "md-expand" }, slot: "md-expand" },
                        [
                          _c(
                            "md-list-item",
                            {
                              staticClass: "md-inset",
                              on: { click: _vm.searchFacility }
                            },
                            [
                              _c("md-icon", [_vm._v("fitness_center")]),
                              _c("span", { staticClass: "md-list-item-text" }, [
                                _vm._v("Facility")
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "md-list-item",
                            {
                              staticClass: "md-inset",
                              on: { click: _vm.searchChain }
                            },
                            [
                              _c("md-icon", [_vm._v("share")]),
                              _c("span", { staticClass: "md-list-item-text" }, [
                                _vm._v("Chain")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "md-list-item",
                    { attrs: { "md-expand": "" } },
                    [
                      _c("md-icon", [_vm._v("build")]),
                      _vm._v(" "),
                      _c("span", { staticClass: "md-list-item-text" }, [
                        _vm._v("Integrator")
                      ]),
                      _vm._v(" "),
                      _c(
                        "md-list",
                        { attrs: { slot: "md-expand" }, slot: "md-expand" },
                        [
                          _c(
                            "md-list-item",
                            {
                              staticClass: "md-inset",
                              on: { click: _vm.createIntegrator }
                            },
                            [
                              _c("md-icon", [_vm._v("add")]),
                              _c("span", { staticClass: "md-list-item-text" }, [
                                _vm._v("Create")
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "md-list-item",
                            {
                              staticClass: "md-inset",
                              on: { click: _vm.listIntegrators }
                            },
                            [
                              _c("md-icon", [_vm._v("list")]),
                              _c("span", { staticClass: "md-list-item-text" }, [
                                _vm._v("Integrators")
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "md-list-item",
                            {
                              staticClass: "md-inset",
                              on: { click: _vm.integratedfacilities }
                            },
                            [
                              _c("md-icon", [_vm._v("fitness_center")]),
                              _c("span", { staticClass: "md-list-item-text" }, [
                                _vm._v("Facilities")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "md-list-item",
                    { on: { click: _vm.convertAccount } },
                    [
                      _c("md-icon", [_vm._v("cached")]),
                      _vm._v(" "),
                      _c("span", { staticClass: "md-list-item-text" }, [
                        _vm._v("Convert Account")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "md-app-content",
            [
              _vm._t("title"),
              _vm._v(" "),
              _c("breadcrumb"),
              _vm._v(" "),
              _vm._t("abstract"),
              _vm._v(" "),
              _vm._t("default")
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "md-snackbar",
        {
          attrs: { "md-active": _vm.showNotification, "md-duration": Infinity },
          on: {
            "update:mdActive": function($event) {
              _vm.showNotification = $event
            },
            "update:md-active": function($event) {
              _vm.showNotification = $event
            }
          }
        },
        [
          _c("span", [_vm._v(_vm._s(_vm.notificationMessage))]),
          _c(
            "md-button",
            {
              staticClass: "md-primary",
              on: {
                click: function($event) {
                  _vm.showNotification = false
                }
              }
            },
            [_vm._v("Close")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e8da6b2c", { render: render, staticRenderFns: staticRenderFns })
  }
}